import React from 'react';
import { Markdown } from '../Markdown';
import { I18n } from '@kineticdata/react';
import { CONTENT_MANAGER_MODE } from '../helpers';

import PortfolioSettingsRenderer from './portfolio_settings';
import PortfolioServicesRenderer from './portfolio_services';
import PortfolioManagementRenderer from './portfolio_management';

import ServiceSettingsRenderer from './service_settings';
import ServiceOfferingsRenderer from './service_offerings';
import ServiceAppendicesRenderer from './service_appendices';
import ServiceCostsRenderer from './service_costs';
import ServiceManagementRenderer from './service_management';
import ServiceDependenciesRenderer from './service_dependencies';

import AppendixSettingsRenderer from './appendix_settings';

import SearchRenderer from './search';
import NewRenderer from './new';

const renderers = [
  // Portfolio Renderers
  PortfolioSettingsRenderer,
  PortfolioServicesRenderer,
  PortfolioManagementRenderer,
  // Service Renderers
  ServiceSettingsRenderer,
  ServiceOfferingsRenderer,
  ServiceAppendicesRenderer,
  ServiceCostsRenderer,
  ServiceManagementRenderer,
  ServiceDependenciesRenderer,
  // Appendix Renderers
  AppendixSettingsRenderer,
  // Other Renderers
  NewRenderer,
  SearchRenderer,
];

export const getValidContentRenderers = type =>
  renderers.filter(r => Array.isArray(r.TYPES) && r.TYPES.includes(type));

export const getContentRenderer = rendererId =>
  (rendererId && renderers.find(r => r.ID === rendererId)) || DefaultRenderer;

const DefaultRenderer = ({
  mode,
  content,
  values,
  activeItem,
  handleContentChange,
  handleContentChangeDirect,
  handleContentDelete,
  handleResetSection,
  actionsPending,
  imageDir,
  sectionIndex,
}) => {
  if (!activeItem) {
    return null;
  }
  const isViewMode = mode !== CONTENT_MANAGER_MODE.EDIT;

  const id = activeItem.id;
  return (
    <>
      <h2>
        {sectionIndex && <small className="text-muted">{sectionIndex}</small>}
        <I18n>{activeItem.title}</I18n>
      </h2>

      <div className="form">
        {!isViewMode ? (
          <>
            <div className="form-group">
              <label htmlFor="title">
                <I18n>Section Title</I18n>
              </label>
              <input
                type="text"
                id="title"
                value={activeItem.title}
                onChange={handleContentChange(id, 'title')}
              />
            </div>
            <div className="form-group">
              <label htmlFor="content">
                <I18n>Section Content</I18n>
              </label>
              <Markdown
                initialValue={activeItem.value}
                onChange={handleContentChangeDirect(id, 'value')}
                imageDir={imageDir}
              />
            </div>

            <DefaultActions
              id={id}
              handleContentDelete={handleContentDelete}
              handleResetSection={handleResetSection}
              isDirty={activeItem.isDirty}
              actionsPending={actionsPending}
            />
          </>
        ) : (
          <Markdown initialValue={activeItem.value} disabled={isViewMode} />
        )}
      </div>
    </>
  );
};

export const DefaultActions = ({
  id,
  handleContentDelete,
  handleResetSection,
  isDirty,
  actionsPending,
}) => (
  <div className="mt-3 d-flex align-items-center">
    {typeof handleContentDelete === 'function' && (
      <button
        className="btn btn-link-danger"
        onClick={handleContentDelete(id)}
        disabled={actionsPending}
      >
        <span className="fa fa-trash fa-fw" />
        Delete Section
      </button>
    )}
    {typeof handleResetSection === 'function' && (
      <button
        className="ml-auto btn btn-link-danger"
        onClick={handleResetSection}
        disabled={!isDirty || actionsPending}
      >
        <span className="fa fa-backspace fa-fw" />
        Reset Section Changes
      </button>
    )}
  </div>
);
